import React from 'react';
import { maskMoney, unmaskMoney } from '../utils/masks';

const ProdutosPfEditor = ({
  produtosPfCatalogo,
  produtosSelecionados,
  buscaProdutoPf,
  loadingProdutosPf,
  error,
  onBuscaChange,
  onAdicionar,
  onRemover,
  onAtualizar
}) => {
  const produtosPfFiltrados = produtosPfCatalogo.filter((item) => {
    if (produtosSelecionados.some((p) => p.catalogo_plano_id === item.id)) return false;
    const q = buscaProdutoPf.trim().toLowerCase();
    if (!q) return true;
    return (
      (item.nome_neo || '').toLowerCase().includes(q) ||
      (item.titulo || '').toLowerCase().includes(q) ||
      (item.filtro_busca || '').toLowerCase().includes(q)
    );
  });

  return (
    <div className="info-section">
      <h4>📦 Produtos PF (NEO)</h4>
      <p style={{ fontSize: '0.85rem', color: 'var(--texto-secundario)', marginBottom: '0.75rem' }}>
        Selecione um ou mais produtos do catálogo PF. O valor total será atualizado automaticamente.
      </p>
      {loadingProdutosPf ? (
        <p>Carregando produtos...</p>
      ) : produtosPfCatalogo.length === 0 ? (
        <p style={{ color: '#ff9800' }}>Nenhum produto PF cadastrado no catálogo.</p>
      ) : (
        <>
          <div className="form-group">
            <label>Buscar produto</label>
            <input
              type="text"
              value={buscaProdutoPf}
              onChange={(e) => onBuscaChange(e.target.value)}
              placeholder="Ex: 600 MEGA, VIVO PLAY..."
              style={{
                width: '100%',
                padding: '0.75rem',
                background: 'var(--cinza-escuro-2)',
                border: `1px solid ${error ? '#f44336' : 'var(--border-color)'}`,
                borderRadius: '6px',
                color: 'var(--texto-primario)'
              }}
            />
            {error && <span className="error-text">{error}</span>}
            {buscaProdutoPf.trim() && produtosPfFiltrados.length > 0 && (
              <div style={{
                marginTop: '0.5rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                maxHeight: '180px',
                overflowY: 'auto'
              }}>
                {produtosPfFiltrados.slice(0, 15).map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => onAdicionar(item)}
                    style={{
                      display: 'block',
                      width: '100%',
                      textAlign: 'left',
                      padding: '0.5rem 0.75rem',
                      border: 'none',
                      borderBottom: '1px solid var(--border-color)',
                      background: 'transparent',
                      color: 'var(--texto-primario)',
                      cursor: 'pointer'
                    }}
                  >
                    {item.titulo || item.nome_neo}
                    {item.valor_padrao != null && (
                      <span style={{ marginLeft: '0.5rem', color: 'var(--texto-secundario)' }}>
                        — R$ {maskMoney(String(Number(item.valor_padrao).toFixed(2)))}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
          {produtosSelecionados.length > 0 && (
            <div style={{ marginTop: '0.75rem' }}>
              {produtosSelecionados.map((p) => (
                <div
                  key={p.catalogo_plano_id}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 90px 110px auto',
                    gap: '0.5rem',
                    alignItems: 'center',
                    marginBottom: '0.5rem',
                    padding: '0.5rem',
                    background: 'rgba(0, 191, 255, 0.05)',
                    borderRadius: '8px'
                  }}
                >
                  <span style={{ fontSize: '0.85rem' }}>{p.nome_neo}</span>
                  <input
                    type="number"
                    min="1"
                    value={p.quantidade}
                    onChange={(e) => onAtualizar(p.catalogo_plano_id, 'quantidade', e.target.value)}
                    title="Quantidade"
                  />
                  <input
                    type="text"
                    value={maskMoney(String(Math.round((parseFloat(p.valor_negociado) || 0) * 100)))}
                    onChange={(e) => onAtualizar(p.catalogo_plano_id, 'valor_negociado', e.target.value)}
                    title="Valor negociado"
                  />
                  <button type="button" className="btn-secondary btn-sm" onClick={() => onRemover(p.catalogo_plano_id)}>
                    Remover
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export const parseProdutosSelecionados = (raw) => {
  if (!raw) return [];
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const somaProdutosPf = (lista) => lista.reduce((acc, p) => {
  const v = parseFloat(String(p.valor_negociado).replace(',', '.')) || 0;
  const q = parseInt(p.quantidade, 10) || 1;
  return acc + v * q;
}, 0);

export const montarObservacaoProdutos = (produtos, observacaoExtra = '') => {
  const nomes = produtos.map((p) => p.nome_neo).join(' + ');
  if (!nomes) return observacaoExtra || '';
  return observacaoExtra ? `${nomes}. ${observacaoExtra}` : nomes;
};

export const serializarProdutosPf = (produtos) => JSON.stringify(
  produtos.map((p) => ({
    catalogo_plano_id: p.catalogo_plano_id,
    nome_neo: p.nome_neo,
    filtro_busca: p.filtro_busca || null,
    valor_negociado: parseFloat(p.valor_negociado) || 0,
    quantidade: parseInt(p.quantidade, 10) || 1
  }))
);

export { unmaskMoney };
export default ProdutosPfEditor;
